import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, defineAsyncComponent } from 'vue';
import { useStore } from '@/store';
export default /*#__PURE__*/_defineComponent({
  __name: 'IncomingEntry',
  setup(__props) {
    const RevenueKanbanManage = defineAsyncComponent(() => import('./index.vue'));
    const RevenueKanbanManageNew = defineAsyncComponent(() => import('@/views/revenueKanbanManageNew/index.vue'));
    const store = useStore();
    const newRevenueUsernames = ['zjxtest', 'wuhanhuitai', 'wuhanduoqu'];
    const incomingComponent = computed(() => {
      var _store$getParsedUserI;
      return newRevenueUsernames.includes((_store$getParsedUserI = store.getParsedUserInfo) === null || _store$getParsedUserI === void 0 ? void 0 : _store$getParsedUserI.username) ? RevenueKanbanManageNew : RevenueKanbanManage;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_resolveDynamicComponent(_unref(incomingComponent)));
    };
  }
});